<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">XML</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="card-body">
            <pre class="bg-light p-3 rounded border" style="max-height: 400px; overflow: auto;">{{ xmlContent }}</pre>
          </div>
        </div>
        <div class="modal-footer">
          <soft-button
            color="secondary"
            @click="closeModal"
            >닫기
          </soft-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import axios from "axios";

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    eventID: {
      type: String,
      default: ""
    },
  },
  emits: ['update:show'],
  components: {
    SoftButton,
  },
  data() {
    return {
      xmlContent: "",
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
        if (this.eventID) {
          this.fetchEventXml(this.eventID);
        }
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  mounted() {
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  methods: {
    async closeModal() {
      this.$emit('update:show', false)
    },
    async fetchEventXml(eventID) {
      try {
        if(eventID){
          const response = await axios.get(`/api/epcisAPI/events`, {
          params: {
              paths: `events/${eventID}`,
            }
          });
          
          const headers = { 'Content-Type': 'application/json' };
          const xmlResponse = await axios.post(
            `/api/gen/generateTestDataXML`,
            JSON.parse(JSON.stringify(response.data)),
            { headers }
          )
          this.xmlContent =  this.formatXml(xmlResponse.data);
        }
      } catch (error) {
        console.log(error)
      }
    },
    formatXml(xml) {
      if (!xml) return '';
      const PADDING = '  '; // 2칸

      // 태그 사이에 개행 삽입
      xml = xml.replace(/(>)(<)(\/*)/g, '$1\n$2$3');

      let pad = 0;
      return xml.split('\n').map((node) => {
        let indent = 0;

        // 닫는 태그 </something>
        if (/^<\/[\w:\-]+>/.test(node.trim())) {
          if (pad > 0) pad -= 1;
        }

        // 여는 태그 <something ...> (self-closing 제외)
        if (/^<[\w:\-]+[^>]*[^/]?>.*$/.test(node.trim()) && !/^<.*>.*<\/.*>$/.test(node.trim())) {
          indent = 1;
        }

        const line = PADDING.repeat(pad) + node.trim();
        pad += indent;
        return line;
      }).join('\n');
    },
  }
}
</script>

<style scoped>
.modal {
  transition: opacity 0.3s ease;
}
.form-select {
  margin-bottom: 12px;
}
</style>